document.addEventListener("DOMContentLoaded", function () {
    // Array of product handles for 10% off with SUMMER10
    const summer10Handles = [
        "aquaplanet-max-10-6-inflatable-paddle-board-package-glacier-v2",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-sunrise",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-prism",
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-coral",
        "aquaplanet-max-plus-118-inflatable-sup-package-beach",
        "aquaplanet-max-plus-118-inflatable-sup-package-horizon",
        "aquaplanet-pace-118-inflatable-paddle-board-package-nori",
        "aquaplanet-pace-118-inflatable-paddle-board-package-ember",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-spectre",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-azure",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-cyber",
        "aquaplanet-inflatable-kayak-two-person",
        "aquaplanet-dry-waterproof-changing-robe-olive",
        "aquaplanet-carbon-fusionlite-paddle-1",
        "kayak-converter-bundle-kayak-seat-sup-kayak-paddle",
        "aquaplanet-compact-3-0-electric-sup-pump",
        "aquaplanet-buoyancy-aid",
        "aquaplanet-waterproof-tote-bag-20l-black"
    ];

    const discountPercentage = 10;
    const discountCode = "SUMMER10";
    const promoText = `with code ${discountCode}`;

    // Function to apply a percentage discount
    function applyPercentageDiscount(priceText, discountPercentage) {
        const price = parseFloat(priceText.replace(/[^0-9.]/g, ""));

        if (isNaN(price)) {
            return null;
        }

        const discountedPrice = price - (price * discountPercentage / 100);
        return `£${discountedPrice.toFixed(2)}`;
    }

    // Get the current URL path
    const urlParts = window.location.pathname.split("/").filter(Boolean);

    const isCollectionPage = urlParts.includes("collections");
    const isProductPage = urlParts.includes("products");

    // 1. Handle collection pages and homepage
    if (isCollectionPage || window.location.pathname === "/") {
        const productCards = document.querySelectorAll(".cl-product-card-inner-container");

        productCards.forEach((card) => {
            const productLink = card.querySelector("a[href*='/products/']");

            if (!productLink) {
                return;
            }

            const productUrlParts = productLink.getAttribute("href").split("/").filter(Boolean);
            const productHandle = productUrlParts[productUrlParts.indexOf("products") + 1];

            if (!summer10Handles.includes(productHandle)) {
                return;
            }

            const priceElement = card.querySelector(".price-variation");

            if (priceElement) {
                const currentPriceText = priceElement.textContent;
                const discountedPrice = applyPercentageDiscount(currentPriceText, discountPercentage);

                if (discountedPrice) {
                    priceElement.textContent = `${discountedPrice} ${promoText}`;
                }
            }
        });
    }

    // 2. Handle product pages
    if (isProductPage) {
        const productHandle = urlParts[urlParts.indexOf("products") + 1];

        if (summer10Handles.includes(productHandle)) {
            // Update main product price
            const priceSnippet = document.querySelector(".product-details-price-snippet .sale-price");

            if (priceSnippet) {
                const currentPriceText = priceSnippet.textContent;
                const discountedPrice = applyPercentageDiscount(currentPriceText, discountPercentage);

                if (discountedPrice) {
                    priceSnippet.textContent = `${discountedPrice} ${promoText}`;
                }
            }

            // Update price in add to cart section if exists
            const formPrice = document.querySelector(".product-form-price .price");

            if (formPrice) {
                const currentPriceText = formPrice.textContent;
                const discountedPrice = applyPercentageDiscount(currentPriceText, discountPercentage);

                if (discountedPrice) {
                    formPrice.textContent = `${discountedPrice} ${promoText}`;
                }
            }
        }
    }
});